// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1W25o","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2hzCl"};